import Skeleton from "react-loading-skeleton";
import "../cssStyles/PaymentWidgetSkeletonShape.css";

const PaymentWidgetSkeletonShape = () => {
  return (
    <div className={`payment_widget__skeleton_style`}>
      <Skeleton
        className={`vas-mt-2`}
        count={2}
        baseColor={"#ebebeb"}
        highlightColor={"#ffffff"}
        inline={true}
        duration={2}
        height={50}
      />
      <div className={`vas-row vas-mt-2 payment_widget__skeleton_row`}>
        <div className={`vas-col-4  `}>
          <div className={`vas-p-1`}>
            <Skeleton
              width={"100%"}
              className={`payment_widget__cards_skeleton_style`}
              baseColor={"#ebebeb"}
              highlightColor={"#ffffff"}
            />
          </div>
        </div>
        <div className={`vas-col-4 `}>
          <div className={`vas-p-1`}>
            <Skeleton
              width={"100%"}
              className={`payment_widget__cards_skeleton_style`}
              baseColor={"#ebebeb"}
              highlightColor={"#ffffff"}
            />
          </div>
        </div>
        <div className={`vas-col-4 `}>
          <div className={`vas-p-1`}>
            <Skeleton
              width={"100%"}
              className={`payment_widget__cards_skeleton_style`}
              baseColor={"#ebebeb"}
              highlightColor={"#ffffff"}
            />
          </div>
        </div>
      </div>
      <br />
      <Skeleton
        className={`vas-mt-2`}
        count={7}
        baseColor={"#ebebeb"}
        highlightColor={"#ffffff"}
        inline={false}
        duration={2}
        height={25}
      />
    </div>
  );
};
export default PaymentWidgetSkeletonShape;
